import React from 'react';
import ReactDOM from 'react-dom/client';
import './override.scss';
import './index.css';
import './css/style.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'formiojs/dist/formio.full.css';
import axios from 'axios';
import { getAuthItem } from './utils/authStorage';

axios.defaults.timeout = 60000;

axios.interceptors.request.use((config) => {
  const token = getAuthItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

function isTimeoutError(message) {
  if (message == null) return false;
  const s = String(message);
  return s === 'Timeout' || s.toLowerCase().includes('timeout');
}

// Suppress React error overlay for "Timeout" errors (capture phase = run before overlay)
window.addEventListener('error', (event) => {
  if (isTimeoutError(event?.message)) {
    console.warn('[Caught] Timeout error:', event.message, event.filename, event.lineno);
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
}, true);

window.addEventListener('unhandledrejection', (event) => {
  const msg = event.reason?.message || String(event.reason);
  if (isTimeoutError(msg)) {
    console.warn('[Unhandled rejection] Timeout:', event.reason?.stack || event.reason);
    event.preventDefault();
    event.stopImmediatePropagation();
  }
}, true);

// Block native drag-out of selected text from inputs/textareas — dragging
// text between form fields was silently overwriting adjacent fields.
window.addEventListener('dragstart', (event) => {
  const tag = event.target?.tagName;
  if (tag === 'INPUT' || tag === 'TEXTAREA') {
    event.preventDefault();
  }
}, true);

// ✅ Custom auto-dismiss alert
window.alert = function (message, type = "success") {
  const alertDiv = document.createElement('div');
  alertDiv.className = `alert alert-${type} position-fixed top-0 start-50 translate-middle-x mt-3 shadow`;
  alertDiv.style.zIndex = '2000';
  alertDiv.style.transition = 'opacity 0.3s ease';
  alertDiv.textContent = message;
  document.body.appendChild(alertDiv);

  // 🕐 Fade out after 1.2 seconds, remove after 1.5
  setTimeout(() => {
    alertDiv.style.opacity = '0';
    setTimeout(() => alertDiv.remove(), 1200);
  }, 1200);
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

reportWebVitals();
